import {AsyncStorage} from "react-native"

export const deleteItemAsync = async (key: string) =>
    await AsyncStorage.removeItem(key)
export const setItemAsync = async (key: string, value: string) =>
    await AsyncStorage.setItem(key, value)
export const getItemAsync = async (key: string) =>
    await AsyncStorage.getItem(key)
